<div class="card card-custom instance-setting-content">
    <div class="row breadcume">
        <div class="col-md-8">
            <div class="row">
                <div class="breadcume-item" *ngFor="let data of breadcrumbData">
                    <h3>
                        <a href="javascript:void(0)" (click)="refreshData(data)">{{ data.name }}</a>
                        <i class="fa fa-angle-right" aria-hidden="true" style="font-size: 20px; margin: 0px 10px; color: #337ab7"></i>
                    </h3>
                </div>
            </div>
        </div>
        <div class="col-md-4 text-center mt-3" *ngIf="_breadcrumbData">
            <mat-checkbox class="example-margin checkbox-wrap" type="checkbox" [checked]="selectAll" (change)="selectionChangeAll($event)">
                Select all/ Deselect all
            </mat-checkbox>
        </div>
    </div>

    <!-- <div class="card-body pt-10 accordian-section new-accordian-scroll">
   <div class="row">
     <div class="col-md-4 mb-5" *ngFor="let item of allowedItemsToDisplay">
       <div class="listing_view">
         <section class="example-section">
           <p>
             <mat-checkbox class="example-margin" type="checkbox" [checked]="getGroupCheckedStatus(item)"
                           (change)="selectionChange($event, item)"  [id]="item.allowedItemId"></mat-checkbox>
             <a [ngClass]=" item.items?'pointer-link':'arrow-link'" (click)="loadData(item)">{{item.name}}</a>
           </p>
         </section>
       </div>
     </div>
   </div>
 </div> -->

    <div class="grid_section-scroll">
        <div class="row grid-view" style="width: 100%; padding: 15px; margin: 0px">
            <ng-container>
                <div class="mb-5 col-md-4" *ngFor="let item of allowedItemsToDisplay">
                    <div class="card card-custom card-shadow">
                        <div class="card_grid">
                            <div class="card_grid_heading d-flex align-items-center justify-content-between">
                                <mat-checkbox
                                    class="example-margin checkbox-wrap"
                                    type="checkbox"
                                    [checked]="getGroupCheckedStatus(item)"
                                    [style.cursor]="item?.items ? 'pointer' : 'default'"
                                    (change)="selectionChange($event, item)"
                                    [id]="item.allowedItemId"
                                    ><span
                                        class="name-wrapper"
                                        [ngClass]="item?.items ? 'pointer-link' : 'arrow-link'"
                                        (click)="loadData(item)"
                                        #tooltip="matTooltip"
                                        matTooltip="{{ item.name }}"
                                        [matTooltipPosition]="'above'"
                                        >{{ item.name }}</span
                                    ></mat-checkbox
                                >
                            </div>
                            <div>
                                <div class="card_grid_footer py-2 row mx-0">
                                    <span class="toolsCount">({{ item?.items?.length > 0 ? item?.items?.length : 0 }} Children)</span>
                                </div>

                                <!--list view hide-->

                                <!-- <div class="col-8 align-items-center d-flex" >
              
              </div>
              <div class="col-4 align-items-center d-flex" >
                <div class="footer_col">

                  <p class="mt-1">({{item?.items?.length > 0 ?item?.items?.length:0}} {{item.name}} Tools)</p>
                </div>
              </div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <p *ngIf="allowedItemsToDisplay?.length === 0" style="margin: 100px 0px; width: 100%; text-align: center; font-size: 24px; color: #ff0b0b">
                    No Result Found
                </p>
            </ng-container>
        </div>
    </div>
</div>
